import React, {useEffect, useState} from "react";
import Paginate from "../../partials/components/Paginate";
import {nanoid} from "nanoid";
import {useNavigate} from "react-router-dom";
import useCandidateDataAPI from "./hooks/useCandidateDataAPI";
import {Skeleton} from "@mui/material";
import PropTypes from "prop-types";
import {Candidate, isOnlyWhiteSpace} from "../../../helpers";
import useAddCandidateAPI from "./hooks/useAddCandidateAPI";
import useAddCandidateDetailsAPI from "./hooks/useAddCandidateDetailsAPI";
import {useParams} from "react-router";
import useGetCandidateEmailAndPhoneAPI from "./hooks/useGetCandidateEmailAndPhoneAPI";
import useGetCandidateDetailsAPI from "./hooks/useGetCandidateDetailsAPI";
import useGetSimilarCandidatesAPI from "./hooks/useGetSimilarCandidatesAPI";
import useCandidateDetailsAPI from "./hooks/useCandidateDetailsAPI";
import InputButton from "../../partials/components/InputButton";
import {ReadMore} from "../../partials/components/ReadMore";
import useRemoveCandidateAPI from "./hooks/useRemoveCandidateAPI";
import DeleteConfirmation from "../../DeleteConfirmation";
import useUpdateCandidateStageAPI from "./hooks/useUpdateCandidateStageAPI";
import useDownloadCandidateProfileAPI from "./hooks/useDownloadCandidateProfileAPI";
import {useDispatch, useSelector} from "react-redux";
import {alertActions} from "../../../redux/actions";
import {useQueryClient} from "react-query";
import InputField from "../../partials/components/InputField";
import {AutoDisabler, ValidationGroup} from 'mui-validate';
import loader from "../../../assets/img/loader.gif"
import dataCircle from "../../../assets/img/back-circle.png";
import useGATrackAPI from "../../Project/hooks/useGATrackAPI";
import useUpdateUserDetails from "../../../hooks/useUpdateUserDetails";
import Timeline from '../../Timeline';

const closeBtn = require('../../../assets/img/close_btn.png');
const linkedin = require('../../../assets/img/linkedin.png');
const github = require('../../../assets/img/github.png');
const twitter = require('../../../assets/img/twitter.png');
const kaggle = require('../../../assets/img/kaggle.png');
const facebook = require('../../../assets/img/facebook.png');
const coffeemug = require('../../../assets/img/cm.png');
const companyDefaultImage = require('../../../assets/img/defaultCompanyImage.jpg')
const userDefaultImage = require('../../../assets/img/default.png')
const educationDefaultImage = require('../../../assets/img/education.png')
const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent);

function CandidateDetails(props) {

    const {candidate} = props;

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {updateUser} = useUpdateUserDetails()
    const socialMediaIcons = {cLinkedin: linkedin, linkedin, github, twitter, kaggle, coffeemug, facebook}

    const [state, setState] = useState({
        page: 1, candidateId: '', showComponent: 'default'
    });

    const handleShowInitialState = {
        AddEmail: false,
        AddPhone: false,
        allLanguages: false,
        allRepos: false,
        allEducations: false,
        allExperiences: false,
        allSkills: false,
        allFocus: false,
        allEmail: false,
        allPhone: false,
        allDataset: false,
        allKernels: false
    }


    const [currentCandidateId, setCurrentCandidateId] = useState('');
    const [handleShow, setHandleShow] = useState(handleShowInitialState);

    const [newCandidateDetails, setCandidateDetails] = useState({
        email: '', emailType: '', phoneType: '', phone: ''
    });
    const [disableCandidateEmailAndPhoneBtn, setDisableCandidateEmailAndPhoneBtn] = useState(false)
    const authUser = useSelector(state => state.authentication.user);
    const [queryEnabled, setQueryEnabled] = useState(false);
    const [candidateDetailsQueryEnabled, setCandidateDetailsQueryEnabled] = useState(false);
    const [singleCandidateQueryEnabled, setSingleCandidateQueryEnabled] = useState(false);
    const [emailAndPhoneApiHitCount, setEmailAndPhoneApiHitCount] = useState(0);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const queryClient = useQueryClient()
    const addCandidateAPI = useAddCandidateAPI();
    const addCandidateDetailsAPI = useAddCandidateDetailsAPI();
    const getCandidateEmailAndPhoneAPI = useGetCandidateEmailAndPhoneAPI({search: currentCandidateId}, queryEnabled);
    const removeCandidateAPI = useRemoveCandidateAPI();
    const updateCandidateStageAPI = useUpdateCandidateStageAPI()
    const {getTrackOfEvent, getGATrackofDetails} = useGATrackAPI();
    const {isLoading, refetch, isRefetching} = useDownloadCandidateProfileAPI({
        candidate: currentCandidateId, enabled: false, onSuccess: (data) => {
            if (data?.status === 'success' || data?.status === 'processing') {

                if (data?.link && !data?.user?.plan_expire_reminder) {
                    window.location.href = data.link
                }

                if (data?.status === 'processing' && !(+localStorage.getItem("isDownloadProfileBtnClicked"))) {
                    setTimeout(() => {
                        localStorage.setItem("isDownloadProfileBtnClicked", '1')
                        queryClient.refetchQueries("getPendingDownloadProfile")
                    }, 5000);
                }
            }

            updateUser(data?.user)

            if (data?.user?.plan_expire_reminder && data?.link) {
                localStorage.setItem("downloadProfile", data.link)
            }
        }
    })

    const {project_id} = useParams();

    let candidateDataAPI = null;
    const CandidateDataAPI1 = useCandidateDataAPI(props.network, {
        candidate: state.candidateId, ...props.filters, projectId: project_id ?? '', ...props?.candidateType
    }, state.page, candidateDetailsQueryEnabled)
    const singleCandidateDataAPI = useCandidateDetailsAPI({
        uuid: currentCandidateId, fullPage: props.fullPage
    }, singleCandidateQueryEnabled);
    if (props.fullPage) {
        candidateDataAPI = singleCandidateDataAPI
        if (candidateDataAPI.isSuccess && !!candidateDataAPI.data?.data?.basic) {
            candidateDataAPI = {
                ...candidateDataAPI,
                data: {user: singleCandidateDataAPI.data.user, data: {candidates: [singleCandidateDataAPI.data.data]}}
            }
        }
    } else {
        candidateDataAPI = CandidateDataAPI1
    }
    const user = candidateDataAPI.data?.user;
    const candidateData = candidateDataAPI.data?.data;
    const getCandidateDetails = useGetCandidateDetailsAPI([currentCandidateId], candidateDetailsQueryEnabled || singleCandidateQueryEnabled);
    const getSimilarCandidatesAPI = useGetSimilarCandidatesAPI({
        candidate: currentCandidateId, similarId: currentCandidateId
    }, candidateDetailsQueryEnabled || singleCandidateQueryEnabled);

    useEffect(() => {

        if (props.candidate) {

            setState({page: props.candidate.position, candidateId: props.candidate.candidateId})

            if (props.candidate.candidateId) {
                setCurrentCandidateId(props.candidate.candidateId)
                setDisableCandidateEmailAndPhoneBtn(false)
                if (props.fullPage) {
                    setSingleCandidateQueryEnabled(true)
                    setCandidateDetailsQueryEnabled(false)
                } else {
                    setCandidateDetailsQueryEnabled(true)
                    setSingleCandidateQueryEnabled(false)
                }
            }
        }
    }, [props.candidate])

    const total = candidateData?.total_record ?? 0;
    const nextPage = candidateData?.nextPage ?? 0;

    if (candidateDataAPI.isSuccess && !props.fullPage) {
        const candidate_uuid = candidateData.candidates?.[0]?.recruitplus?.uuid;
        if (candidate_uuid !== currentCandidateId) {
            setHandleShow(handleShowInitialState)
            setCurrentCandidateId(candidate_uuid)
            setQueryEnabled(false)
            setEmailAndPhoneApiHitCount(0)
            setCandidateDetailsQueryEnabled(true)
            setDisableCandidateEmailAndPhoneBtn(false)
            setHandleShow(prevState => ({...prevState, AddEmail: false, AddPhone: false}))
        }
    }

    if (addCandidateAPI.status === 'success') {
        // setState(prevState => ({...prevState, showComponent: 'success'}))
        addCandidateAPI.reset()
    }
    if (addCandidateAPI.status === 'error') {
        setState(prevState => ({...prevState, error: addCandidateAPI.error, showComponent: 'error'}))
        addCandidateAPI.reset()
    }

    const prepareLink = ({socialLinks, key}) => {
        return socialLinks[key].startsWith('https://') ? socialLinks[key] : 'https://' + socialLinks[key];
    }

    const getSocialLinkList = ({socialLinks, key}) => {

        if (socialLinks && socialLinks[key] && key in socialMediaIcons) {
            return <li key={key}>
                <a href={prepareLink({socialLinks, key})} target="_blank" rel="noreferrer">
                    <img
                        src={socialMediaIcons[key]}
                        alt=""/>
                </a>
            </li>
        }
    }

    const openLinkedIn = (candidate) => {
        const socialLinks = candidate?.basic?.social_links ?? candidate?.basic?.socialLinks;
        const link = candidate?.basic?.canonical_url ?? socialLinks['linkedin'];


        getGATrackofDetails("Open LinkedIn")
        window.open(link.startsWith('https://') ? link : 'https://' + link, "_blank", "noreferrer")
    }

    const openCompanyLinkedIn = (companyLinkedinUrl) => {
        const lastWord = companyLinkedinUrl?.split('/').pop();
        const link = lastWord ? `https://www.linkedin.com/company/${lastWord}` : 'https://www.linkedin.com/company/unavailable/';
        window.open(link, '_blank', 'noreferrer');
    };
    const similarProfile = () => {
        getGATrackofDetails("Similar Profile")
        const url = `${process.env.REACT_APP_BASENAME}/similar-candidate/${currentCandidateId}`;
        window.open(url, '_blank');

    }

    const formatSocialLinks = (socialLinks, candidate = null) => {
        const coffeemugLink = candidate?.coffeemug?.url
        if (candidate?.basic?.canonical_url) {
            const len = candidate.basic.canonical_url.split('/')
            const len1 = socialLinks['linkedin'].split('/')
            if (len[len.length - 1] !== len1[len1.length - 1]) {
                socialLinks.cLinkedin = candidate.basic.canonical_url
            }
        }
        if (coffeemugLink) {
            socialLinks.coffeemug = coffeemugLink
        }

        const socialLinksJsx = []
        if (socialLinks) {
            if (socialLinks['cLinkedin']) socialLinksJsx.push(getSocialLinkList({socialLinks, key: 'cLinkedin'}))
            if (socialLinks['linkedin']) socialLinksJsx.push(getSocialLinkList({socialLinks, key: 'linkedin'}))
            if (socialLinks['coffeemug']) socialLinksJsx.push(getSocialLinkList({socialLinks, key: 'coffeemug'}))
            const links = ['cLinkedin', 'linkedin', 'coffeemug']

            Object.keys(socialLinks).forEach((key) => {
                if (socialLinks[key] && !links.includes(key)) {
                    socialLinksJsx.push(getSocialLinkList({socialLinks, key}))
                }
            });
        }

        return socialLinksJsx
    }

    const createPersonaData = (personaDetails) => {
        if (!personaDetails?.title) {
            return []
        }

        return ['Reactor', 'Initiator', 'Director', 'Observer'].map((persona, key) => {
            if (`The ${persona}` === personaDetails?.title) {
                return (<li className="active" key={key}>
                    <div>{persona}</div>
                    <span className="tooltip-text">{personaDetails.description}</span>
                </li>)
            } else {
                return <li key={key}>{persona}</li>
            }
        })
    }


    useEffect(() => {
        let timeoutId;
        if (getCandidateEmailAndPhoneAPI.isSuccess && queryEnabled && getCandidateEmailAndPhoneAPI?.data?.retry && emailAndPhoneApiHitCount > 0 && emailAndPhoneApiHitCount <= 15) {

            if (Notification.permission !== 'granted' && getCandidateEmailAndPhoneAPI?.data?.message === 'Fetching contact details from the open web. This may take a while. Apologies for any inconvenience.') {
                Notification.requestPermission();
            }

            timeoutId = setTimeout(() => {
                getCandidateEmailAndPhoneAPI.refetch().then(() => {
                    setEmailAndPhoneApiHitCount(prevState => prevState + 1)
                })

            }, 2000)
        }

        return () => {
            clearTimeout(timeoutId)
        }

    }, [emailAndPhoneApiHitCount, getCandidateEmailAndPhoneAPI.isSuccess])


    let emailData = [];
    let phoneData = [];
    let accurate = null;
    const createPhoneAndEmailHtml = ({email, phone, accuracy = null, status = null, message = null}) => {
        const emailHtml = []
        const phoneHtml = []
        emailData = []
        phoneData = []

        if (email) {
            // const gmailYahooEmails = email.filter(mail => mail.value.endsWith("@gmail.com") || mail.value.endsWith("@yahoo.com"))
            const emails = email;

            emails?.slice(0, handleShow.allEmail ? undefined : 5).map(function ({value_type, value, source}, k) {
                if (source !== 'CDA' && !disableCandidateEmailAndPhoneBtn) {
                    setDisableCandidateEmailAndPhoneBtn(true)
                }
                emailHtml.push(<a href={`mailto:${value}`} key={k}>
                    {value}
                </a>)
            })
        }

        if (phone) {
            // const phonesWithoutEighteenHundred = phone.filter(mobile => !mobile.value.toString().startsWith('+91 18 00') || !mobile.value.toString().startsWith('+91 1800') || !mobile.value.toString().startsWith('18 00') || !mobile.value.toString().startsWith('1800')
            //     || !mobile.value.toString().startsWith('+0 18 00') || !mobile.value.toString().startsWith('+0 1800'))


            phone?.slice(0, handleShow.allPhone ? undefined : 5).map(function ({
                                                                                   value_type, value, source
                                                                               }, j) {
                if (source !== 'CDA' && !disableCandidateEmailAndPhoneBtn) {
                    setDisableCandidateEmailAndPhoneBtn(true)
                }

                phoneHtml.push(<a href={`tel:${value}`} key={j}>
                    {value}
                </a>)
            })
        }

        accurate = accuracy
        const noEmailFoundMsg = status === 'CREDIT_REACH' ? message : `No email found (Contact Via Linkedin)`;
        const noPhoneFoundMsg = status === 'CREDIT_REACH' ? message : `No phone found`;

        emailData.push(<>
            <div className="inline_anchor">
                {emailHtml}
                {email?.length > 5 && <button className="show_more_btn mt-0" onClick={() => {
                    setHandleShow(prevState => ({...prevState, allEmail: !prevState.allEmail}))
                }}>{handleShow.allEmail ? 'Show less' : 'Show more'}</button>}
            </div>
            {emailHtml.length === 0 && <span className="no_data">{noEmailFoundMsg}  </span>}
            {!handleShow.AddEmail &&
                <span className={handleShow.AddEmail ? 'add plus_icon add_active' : 'add plus_icon'}
                      onClick={() => {
                          setHandleShow(prevState => ({...prevState, AddEmail: true, AddPhone: false}))
                      }}>
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 1.5V9.5M9 5.5H1" stroke="#D8232A" strokeWidth="1.5" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg> Add Email
                    </span>}
        </>)

        phoneData.push(<>
            <div className="inline_anchor">
                {phoneHtml}
                {phone?.length > 5 && <button className="show_more_btn mt-0" onClick={() => {
                    setHandleShow(prevState => ({...prevState, allPhone: !prevState.allPhone}))
                }}>{handleShow.allPhone ? 'Show less' : 'Show more'}</button>}
            </div>
            {phoneHtml.length === 0 && <span className="no_data"> {noPhoneFoundMsg} </span>}
            {!handleShow.AddPhone &&
                <span className={handleShow.AddPhone ? 'add plus_icon add_active' : 'add plus_icon'}
                      onClick={() => {
                          setHandleShow(prevState => ({...prevState, AddEmail: false, AddPhone: true}))
                      }}>
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 1.5V9.5M9 5.5H1" stroke="#D8232A" strokeWidth="1.5" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg> Add Phone
                    </span>}
        </>)
    }

    if (getCandidateEmailAndPhoneAPI.isError) {
        if (getCandidateEmailAndPhoneAPI?.error?.error === 'CREDIT_REACH' || getCandidateEmailAndPhoneAPI?.error?.status === 'NO_DATA_FOUND') {
            if (queryEnabled) {
                setDisableCandidateEmailAndPhoneBtn(true)
                setEmailAndPhoneApiHitCount(0)
                setQueryEnabled(false)

                if (getCandidateEmailAndPhoneAPI?.error?.user) {
                    updateUser(getCandidateEmailAndPhoneAPI?.error?.user)
                }
            }
        }

        if (!getCandidateEmailAndPhoneAPI?.error?.message) {
            dispatch(alertActions.error("Something went wrong please try again later"));
        }

        createPhoneAndEmailHtml({
            email: [],
            phone: [],
            status: getCandidateEmailAndPhoneAPI?.error?.error ?? '',
            message: getCandidateEmailAndPhoneAPI?.error?.message ?? ''
        })
    }

    if (getCandidateEmailAndPhoneAPI.isSuccess) {
        if (getCandidateEmailAndPhoneAPI.data) {
            if (getCandidateEmailAndPhoneAPI?.data?.status === 'NO_DATA_FOUND') {
                if (queryEnabled) {
                    setQueryEnabled(false)
                    setEmailAndPhoneApiHitCount(0)
                    setDisableCandidateEmailAndPhoneBtn(true)
                }
                createPhoneAndEmailHtml({
                    email: [],
                    phone: [],
                    status: getCandidateEmailAndPhoneAPI?.data?.status,
                    message: getCandidateEmailAndPhoneAPI?.data?.message
                })
            }

            if (getCandidateEmailAndPhoneAPI?.data?.data?.email?.length || getCandidateEmailAndPhoneAPI?.data?.data?.phone?.length) {
                if (emailAndPhoneApiHitCount > 0) {
                    setEmailAndPhoneApiHitCount(0)
                    setQueryEnabled(false)
                    updateUser(getCandidateEmailAndPhoneAPI?.data?.user)
                }

                const {email, phone, accuracy} = getCandidateEmailAndPhoneAPI.data.data;

                createPhoneAndEmailHtml({email, phone, accuracy})
            }
        }
    }

    const candidateInProject = [];
    if (getCandidateDetails.isSuccess && getCandidateDetails?.data?.data) {
        const data = getCandidateDetails?.data?.data

        data.forEach((row) => {
            if (row.uuid === currentCandidateId) {
                if (row?.email || row?.phone) {
                    const {email, phone, accuracy} = row
                    createPhoneAndEmailHtml({email, phone, accuracy})
                }

                if (row?.candidateInProject) {
                    row?.candidateInProject?.forEach((project) => {
                        candidateInProject.push(
                            <div key={project.project_id}>
                        <span
                            title={project?.project?.name}>{(project?.project?.name && project.project.name.length > 10) ? project.project.name.slice(0, 9) + '...' : project.project.name}</span>
                                <select className="btn btn_outline btn_sm stage" value={project?.stage}
                                        onChange={(e) => {
                                            updateCandidateStageAPI.mutate({
                                                candidate_uuid: currentCandidateId,
                                                stage: e.target.value,
                                                project_id: project.project_id,
                                                projectUuid: project_id,
                                                page: props.candidateOnPage
                                            })
                                        }}>
                                    <option value="Uncontacted">Uncontacted</option>
                                    <option value="Contacted">Contacted</option>
                                    <option value="Rejected">Rejected</option>
                                </select>
                            </div>)
                    })
                }
            }
        })

    }

    if (addCandidateDetailsAPI.isSuccess) {
        setCandidateDetails(prevState => ({...prevState, emailType: '', email: '', phoneType: '', phone: ''}));
        setHandleShow(prevState => ({...prevState, AddEmail: false, AddPhone: false}))
        getCandidateDetails.refetch();
        addCandidateDetailsAPI.reset();
    }

    const getNextPage = (page) => {
        if (page) {
            setState(prevState => ({...prevState, page: page}))
        } else {
            setState(prevState => ({...prevState, page: nextPage}))
        }
    }
    const capitalizeFirst = str => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    const getStar = (rating) => {
        if (typeof rating !== 'number') {
            return false
        }
        if (rating < 0.2) {
            return <ion-icon name="star-half"></ion-icon>
        }
        let star = 0;
        if (rating) {
            star = Math.floor(rating * 5)
        }
        return (<>
            <div className="star">
                {[...Array(star)].map((el, index) => <ion-icon key={index} name="star"></ion-icon>)}
            </div>
        </>)
    }

    const handleChange = (e) => {
        const {name, value} = e.target;
        setCandidateDetails(prevState => ({...prevState, [name]: value}))
    }

    const saveToPipeline = (type = '') => {
        if (type === 'removeFromPipeline') {
            removeCandidateAPI.mutate({
                project: project_id,
                candidate_uuid: [currentCandidateId],
                page: props.candidateOnPage,
                detailsPage: state.page
            })
        } else {
            if (project_id) {
                addCandidateAPI.mutate({status: '1', candidate_uuid: [currentCandidateId], project: project_id})
            } else {
                props.openSaveToPipeline([currentCandidateId])
            }
        }
    }

    if (removeCandidateAPI.isSuccess) {
        removeCandidateAPI.reset()
        if (state.page > 1) setState(prevState => ({...prevState, page: state.page - 1}))
        setDeleteModalOpen(false)
    }

    if (!props?.candidate?.showModal && !props.fullPage && (deleteModalOpen || queryEnabled)) {
        setDeleteModalOpen(false)
        setQueryEnabled(false)
        setEmailAndPhoneApiHitCount(0)
    }

    const addCandidateDetailsFunc = (e, name) => {
        e.preventDefault();

        if (name === "saveCandidateEmail") {
            const {emailType, email} = newCandidateDetails;

            addCandidateDetailsAPI.mutate({
                type: "email", uuid: currentCandidateId, value_type: 'personal', value: email
            });
        } else if (name === "saveCandidatePhone") {
            const {phoneType, phone} = newCandidateDetails;

            addCandidateDetailsAPI.mutate({
                type: "phone", uuid: currentCandidateId, value_type: 'personal', value: phone
            });
        }
    }

    const getPhoneAndEmail = (e) => {
        e.preventDefault();
        setQueryEnabled(true);
        getGATrackofDetails("Phone and Email");
        setEmailAndPhoneApiHitCount(prevState => prevState + 1)
    }

    let detailsDiv = '', similarDiv = '', isCoffeemugMember = false, candidateName = '', githubAndSimilar = ''

    function handleClick(link, newTab) {
        return () => {

            if (newTab) {
                window.open(link, '_blank');
            } else {
                navigate(link);
            }
        }
    }

    if (getSimilarCandidatesAPI.isLoading || candidateDataAPI.isLoading) {
        similarDiv = <>
            <div className="autho_info_desk">
                <div>
                    <div className="author_info sidebar_container">
                        <div id="accordion">
                            {props?.network?.forGithub && <>
                                <div className="git_title"><h3 className="author_title"><Skeleton variant="text"
                                                                                                  sx={{width: '126px'}}/>
                                </h3></div>
                                <div className="collapse_row_1 sidebar_row mb_10">
                                    <ul>
                                        <li className="rp-git-lang">
                                            <h4><Skeleton variant="text" sx={{width: '100px'}}/></h4>
                                            <div className="star">
                                                <span><Skeleton variant="text" sx={{width: '126px'}}/></span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="collapse_row_2 sidebar_row mb_10">
                                    <h4><Skeleton variant="text" sx={{width: '130px'}}/></h4>
                                    <ul>
                                        {Array(5).fill(1).map((i, j) => (<li className="rp-git-lang" key={j}>
                                            <span><Skeleton variant="text" sx={{width: '90px'}}/></span>
                                            <div className="star">
                                                <span><Skeleton variant="text" sx={{width: '127px'}}/></span>
                                            </div>
                                        </li>))}
                                    </ul>
                                </div>
                                <div className="collapse_row_3 sidebar_row mb_10">
                                    <h4><Skeleton variant="text" sx={{width: '130px'}}/></h4>
                                    <ul>
                                        {Array(5).fill(1).map((i, j) => (<li className="rp-git-lang" key={j}>
                                            <span><Skeleton variant="text" sx={{width: '90px'}}/></span>
                                            <div className="star">
                                                <span><Skeleton variant="text" sx={{width: '127px'}}/></span>
                                            </div>
                                        </li>))}
                                    </ul>
                                </div>
                            </>}

                            <div className="collapse_row_4">
                                <h4><Skeleton variant="text" sx={{width: '126px'}}/></h4>
                                <div className="collapse_layout">
                                    <ul>
                                        {Array(props?.network?.forGithub ? 5 : 10).fill(1).map((i, j) => (
                                            <li className="rp-link" key={`similar-${j}`}>
                                                <div className="sm_img">
                                                    <Skeleton variant="circular" width={70} height={70}/>
                                                </div>
                                                <div className="sm_content">
                                                    <h5><Skeleton variant="text" sx={{width: '72px'}}/></h5>
                                                    <div className="user_designations">
                                                        <span className="rp_user_1"><Skeleton variant="text"
                                                                                              sx={{width: '134px'}}/></span>
                                                    </div>
                                                    <div>
                                                        <Skeleton variant="text" sx={{width: '134px'}}/>
                                                    </div>
                                                </div>
                                            </li>))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*<div className="rp-top">*/}
            {/*    <div className="similar_section">*/}
            {/*        <h3 className="author_title">*/}
            {/*            <Skeleton variant="text" sx={{width: '150px', height: '35px'}}/></h3>*/}
            {/*        <ul className="similar_list">*/}
            {/*            {[1, 2, 3].map((i) => <li key={i}>*/}
            {/*                <div className="">*/}
            {/*                    <Skeleton variant="circular" width={70} height={70}/>*/}
            {/*                </div>*/}
            {/*                <div className="sm_con">*/}
            {/*                    <h4>*/}
            {/*                        <Skeleton variant="text"*/}
            {/*                                  sx={{width: '100px', marginLeft: '0px !important'}}/>*/}
            {/*                        <Skeleton variant="rectangular" sx={{*/}
            {/*                            width: '60px', height: '20px', borderRadius: "20px"*/}
            {/*                        }}/>*/}
            {/*                    </h4>*/}
            {/*                    <h5><Skeleton variant="text" sx={{width: '100%'}}/></h5>*/}
            {/*                    <h5><Skeleton variant="text" sx={{width: '80%'}}/></h5>*/}
            {/*                </div>*/}
            {/*            </li>)}*/}
            {/*        </ul>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </>
    }

    if (getSimilarCandidatesAPI.isSuccess && candidateDataAPI.isSuccess) {
        similarDiv = <>
            <div className="collapse_row_4">
                <h4>Similar Profiles</h4>
                <div className="collapse_layout" key='similarCandidate'>
                    <ul>
                        {(getSimilarCandidatesAPI?.data?.data ?? []).map((sim, k) => {
                            if (!sim?.basic?.current_title) {
                                return <li key={k}></li>
                            }
                            return <li key={k}
                                       onClick={(() => navigate(`${process.env.REACT_APP_BASENAME}/profile/${sim.recruitplus.uuid}`))}
                                       className="rp-link">
                                <div className="sm_img">
                                    <img src={sim.basic?.image_url ?? userDefaultImage}
                                         onError={({currentTarget}) => currentTarget.src = userDefaultImage} alt=""/>
                                </div>
                                <div className="sm_content">
                                    <h5 title={sim.basic?.fullname}>{sim.basic?.fullname}</h5>
                                    {sim?.current_position && Object.keys(sim?.current_position).length > 0 &&
                                        <div className="user_designations">
                                            {sim.current_position?.c_seniority && <>
                                                <span title={sim.current_position?.c_seniority}
                                                      className="rp_user_1">{sim.current_position?.c_seniority}</span>
                                                <span className="rp_user_2">@</span>
                                            </>}
                                            {sim.current_position?.company &&
                                                <span title={sim.current_position?.company}
                                                      className="rp_user_3">{sim.current_position?.company}</span>}
                                        </div>}
                                    {/*<div className="switch">
                                        <span>Likely to Switch</span>
                                        <span>{sim.recruitplus?.availability_level}</span>
                                    </div>*/}
                                </div>
                            </li>
                        })}
                        <li key="seeAll">
                            <a onClick={() => {
                                similarProfile()
                            }} className="show_more_btn">See all Profiles</a>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    }

    if (candidateDataAPI.status === 'loading') {
        detailsDiv = <>
            <div className="mb_10 author_content">
                <div className="user_all_details">
                    <div className="user_profl">
                        <div>
                            <div className="userimage"><Skeleton variant="circular"
                                                                 sx={{width: '70px', height: '70px'}}/></div>
                        </div>
                    </div>
                    <div className="user_details_area">
                        <div className="user_detail">
                            <div className="template_user_name"><h3><Skeleton variant="text" sx={{width: '120px'}}/>
                            </h3>
                            </div>
                            <div className="user_designation">
                                <Skeleton variant="text" sx={{width: '484px'}}/>
                            </div>
                            <div className="user_address"><Skeleton variant="text" sx={{width: '484px'}}/></div>
                            <div className="perfomance_row"><p><Skeleton variant="text" sx={{width: '120px'}}/></p>
                                <ul>
                                    {[1, 2, 3, 4, 5].map((i) => <Skeleton key={i} variant="text"
                                                                          sx={{width: '35px'}}/>)}
                                </ul>
                                <span><Skeleton variant="text" sx={{width: '50px'}}/></span></div>
                        </div>
                    </div>
                </div>
                <div className="user_other_info">
                    {/*<ul className="usr_info">*/}
                    {/*    <li>*/}
                    {/*        <div className="lt_icon text-end">*/}
                    {/*            <img className="likely_svg"*/}
                    {/*                 src="/talentos/assets/images/likely-to-respond.svg"*/}
                    {/*                 alt="Likely to Switch"/>*/}
                    {/*            </div>*/}
                    {/*        <div className="rt_con social_bar">*/}
                    {/*            <div>*/}
                    {/*                <div className="perfomance_row">*/}
                    {/*                    <p>Likely to Respond</p>*/}
                    {/*                    <ul>*/}
                    {/*                        {[1, 3, 5, 8, 10].map((i) => <li key={i}*/}
                    {/*                                                         className={availabilityScore < i ? '' : 'active'}></li>)}*/}

                    {/*                    </ul>*/}
                    {/*                    <span>{availabilityVal}</span>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </li>*/}
                    {/*</ul>*/}
                    <ul className="usr_info">
                        <li>
                            <div className="lt_icon">
                                <span><Skeleton variant="text" sx={{width: '81px'}}/></span></div>
                            <div className="rt_con">
                                <div className="add_cd"><Skeleton variant="text" sx={{width: '300px'}}/></div>
                            </div>
                        </li>
                        <li>
                            <div className="lt_icon">
                                <span><Skeleton variant="text" sx={{width: '81px'}}/></span></div>
                            <div className="rt_con">
                                <div className="add_cd"><Skeleton variant="text" sx={{width: '300px'}}/></div>
                            </div>
                        </li>
                        <li>
                            <div className="lt_icon">
                                <span><Skeleton variant="text" sx={{width: '81px'}}/></span></div>
                            <div className="rt_con social_bar">
                                <ul>
                                    {[1, 2, 3, 4, 5].map((i) => <li key={i}><Skeleton variant="circular" sx={{
                                        width: '15px', height: '15px'
                                    }}/>
                                    </li>)}
                                </ul>
                            </div>
                        </li>
                    </ul>
                    <div className="user_right">
                        <Skeleton variant="text" sx={{width: '165px', height: '40px'}}/>
                        <Skeleton variant="text" sx={{width: '150px', height: '40px'}}/>
                        <Skeleton variant="text" sx={{width: '112px', height: '40px'}}/>
                    </div>
                </div>
            </div>
            <div className="mb_10 about_section">
                <div className="content">
                    <div className="sub_title">
                        <h2><Skeleton variant="text" sx={{width: '180px', height: '30px'}}/></h2>
                        <p><Skeleton variant="rectangular" sx={{width: '100%', height: "30px"}}/></p>
                    </div>
                </div>
            </div>
            <div className="mb_10 experience_section">
                <div className="content">
                    <div className="sub_title">
                        <h2><Skeleton variant="text" sx={{width: '180px', height: '30px'}}/></h2>
                    </div>
                    <div className="exp_list_row">
                        <ul>
                            {[1, 2, 3].map((i) => <li key={i}>
                                <div className="content_row content_list">
                                    <Skeleton variant="rectangular" sx={{width: '60px', height: '50px'}}/>
                                    <div className="item-title">
                                        <h4><Skeleton variant="text" sx={{width: '140px', height: '20px'}}/></h4>
                                        <h5><span><Skeleton variant="text"
                                                            sx={{width: '150px', height: '20px'}}/></span></h5>
                                        <h6><Skeleton variant="text" sx={{width: '140px', height: '20px'}}/></h6>
                                    </div>
                                </div>
                                <div className="content_list timeline_row">
                                    <div></div>
                                    <div className="item-title">
                                        <p><Skeleton variant="rectangular" sx={{width: '100%', height: "40px"}}/></p>
                                    </div>
                                </div>
                            </li>)}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="mb_10 eduction_section">
                <div className="content">
                    <div className="sub_title">
                        <h2><Skeleton variant="text" sx={{width: '180px', height: '30px'}}/></h2>
                    </div>
                    <div className="exp_list_row">
                        <ul>
                            {[1, 2, 3].map((i) => <li key={i}>
                                <div className="content_row content_list">
                                    <Skeleton variant="rectangular" sx={{width: '60px', height: '50px'}}/>
                                    <div className="item-title">
                                        <h4><Skeleton variant="text" sx={{width: '350px', height: '20px'}}/></h4>
                                        <h5><span><Skeleton variant="text"
                                                            sx={{width: '200px', height: '20px'}}/></span></h5>
                                        <h6><Skeleton variant="text" sx={{width: '140px', height: '20px'}}/></h6>
                                        <span><Skeleton variant="text" sx={{width: '100px', height: '20px'}}/></span>
                                    </div>
                                </div>
                            </li>)}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="mb_10 skill_section">
                <div className="content">
                    <div className="sub_title">
                        <h2><Skeleton variant="text" sx={{width: '180px', height: '30px'}}/></h2>
                    </div>
                    <div className="inline_pills">
                        <ul className="">
                            {[1, 2, 3, 5, 6, 7, 8, 9, 10, 11].map((i) => <Skeleton key={i} variant="rectangular" sx={{
                                width: '90px', height: '27px', borderRadius: "20px", marginRight: '10px'
                            }}/>)}
                        </ul>
                    </div>
                </div>
            </div>
        </>;
        githubAndSimilar = similarDiv
    } else if (candidateDataAPI.status === 'success') {
        if (candidateData.length === 0) {
            return <span>No data found</span>;
        }
        const candidate = new Candidate(candidateData?.candidates?.[0] ?? {});
        isCoffeemugMember = candidate?.coffeemug ? true : false
        candidateName = candidate?.basic?.fullname
        const positionsArr = [], qualificationsArr = [];
        const companyArrangedList = {};
        const companiesSortedByOrder = candidate?.positions?.sort((a, b) => a?.order - b?.order)

        let companyName = '';
        companiesSortedByOrder?.forEach((position, i) => {
            if (!companyArrangedList[i] && companyName !== position.company) {
                companyArrangedList[i] = [position]
                companyName = position.company;
            } else if (position.company === companyName) {
                const lastKey = Object.keys(companyArrangedList);
                companyArrangedList[lastKey[lastKey.length - 1]].push(position)
            }
        });

        Object.values(companyArrangedList).slice(0, handleShow.allExperiences ? undefined : 2).map((companies, companyKey) => {
            const companiesHtml = []
            const companiesDetails = {
                startDate: companies[companies.length - 1]?.startDate ?? '',
                endDate: companies[0]?.endDate === null ? 'present' : companies[0]?.endDate,
                totalCompanies: companies.length
            }
            companies?.forEach(({
                                    company,
                                    title,
                                    startDate,
                                    endDate,
                                    companyImage,
                                    description,
                                    industries,
                                    li_username,
                                    li_url
                                }, key) => {
                let industriesNames = '';
                /*if (industries) {
                    industriesNames = industries?.map(industry => industry.name).join(", ")
                }*/
                companiesHtml.push(<li key={key}>
                    <div className="content_row content_list">
                        {key === 0 ? <div className="comp_image cursor-pointer"><a
                            onClick={() => openCompanyLinkedIn(li_username ?? li_url)} target="_blank"><img
                            src={companyImage ?? companyDefaultImage}
                            onError={({currentTarget}) => currentTarget.src = companyDefaultImage}
                            alt=""/></a></div> : <div></div>}
                        <div className="item-title">
                            {companiesDetails.totalCompanies > 1 ? <>
                                {key === 0 ? <h4>{company}</h4> : <h5 dangerouslySetInnerHTML={{__html: title}}></h5>}
                            </> : <>
                                <h4>{company}</h4>
                                <h5><span dangerouslySetInnerHTML={{__html: title}}></span></h5>
                            </>}
                            {/*{key === 0 && industriesNames && <span>({industriesNames})</span>}*/}
                            <h6>{key === 0 ? companiesDetails.startDate : startDate} - {key === 0 ? companiesDetails.endDate : (endDate ?? 'present')}</h6>
                        </div>
                    </div>
                    <div className="content_list timeline_row">
                        <div></div>
                        <div className="item-title">
                            {companiesDetails.totalCompanies > 1 && key === 0 && <>
                                <h5 dangerouslySetInnerHTML={{__html: title}}></h5>
                                <h6>{startDate} - {endDate ?? 'present'}</h6>
                            </>}
                            <ReadMore size={230} text={description}/>
                        </div>
                    </div>
                </li>)
            })

            positionsArr.push(<ul className={companies?.length > 1 ? 'timeline_style' : ''} key={companyKey}>
                {companiesHtml}
            </ul>)
        })

        if (candidate?.educations?.length > 0) {
            const educationByDuration = candidate?.educations?.sort((a, b) => {

                return b.startYear - a.startYear
            })

            educationByDuration?.slice(0, handleShow.allEducations ? undefined : 2).map(
                ({school, degree, startYear, major, endYear, description}, key) => {
                    qualificationsArr.push(<li key={key}>
                        <div className="content_list">
                            <div className="comp_image">
                                <img src={educationDefaultImage} alt={school}/>
                            </div>
                            <div className="item-title title_style">
                                <h4>{school}</h4>
                                {degree && <h5>{degree} {major?.length > 0 && `, ${major}`}</h5>}
                                {startYear && endYear && <h6>{startYear} - {endYear}</h6>}
                                <ul className="edu_info">
                                    <li>{description}</li>
                                </ul>
                            </div>
                        </div>
                    </li>)
                })
        }

        const github = candidate?.other_sources?.github;

        const skills = []
        const calculatedSkills = candidate.recruitplus.calculated_skills;
        const chunkSize = 4;
        for (let i = 0; i < calculatedSkills.length; i += chunkSize) {
            skills.push(calculatedSkills.slice(i, i + chunkSize))
        }

        let sortedRepos = []
        let languageSortedByRating = []
        const profileViewed = candidateDataAPI?.data?.data?.candidates[0]?.recruitplus?.profile_viewed ?? false;
        const availabilityScore = candidateDataAPI?.data?.data?.candidates[0]?.recruitplus?.availability_score ?? 0;
        let availabilityVal = candidateDataAPI?.data?.data?.candidates[0]?.recruitplus?.availability_level ?? 'Low';
        if (availabilityVal === '') {
            availabilityVal = 'Low';
        }

        if (props.network?.forGithub) {
            const topRatedLanguage = github?.pinnedrepos?.map((top) => top.name);
            const topRated = github?.repos?.filter((row) => topRatedLanguage.includes(row?.name ?? ''));
            const removedTopRated = github?.repos?.filter((row) => !topRatedLanguage.includes(row?.name ?? ''));
            sortedRepos = removedTopRated ? topRated.concat(removedTopRated) : []
            languageSortedByRating = github?.languages?.filter(row => 'rating' in row)
            languageSortedByRating = languageSortedByRating.sort((a, b) => {

                return b.rating - a.rating
            })
        }
        let fullTimeYearsText = Math.round(candidate?.recruitplus?.full_time_years) + ' Yrs';
        if (candidate?.recruitplus?.full_time_years_text) {
            fullTimeYearsText = candidate?.recruitplus?.full_time_years_text;
        }
        detailsDiv = <>
            <div className="mb_10 author_content">
                <div className="user_all_details">
                    <div className={candidate?.coffeemug ? 'user_profl bg_after' : 'user_profl'}>
                        <div>
                            <div className="userimage">
                                <img className="user_img"
                                     src={candidate.basic.image_url ?? userDefaultImage}
                                     onError={({currentTarget}) => currentTarget.src = userDefaultImage}
                                     alt="image"/>
                                {availabilityVal === 'High' && <div className="likely_img">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/likely_img.png`} alt=""/>
                                </div>}
                                {props.network?.forGithub && <div className="coder_score_budge">
                                    <span>{candidate?.other_sources?.github?.profile_rank}</span>
                                    <ion-icon name="star" role="img" className="md hydrated"
                                              aria-label="star"></ion-icon>
                                </div>}
                            </div>
                        </div>
                    </div>

                    <div className="user_details_area">
                        <div className="user_detail">
                            <div className="template_user_name">
                                <h3>
                                    <span className={`rp-link ${profileViewed ? 'profile_viewed' : ''}`}
                                          onClick={handleClick(`${process.env.REACT_APP_BASENAME}/profile/${candidate.recruitplus.uuid}`, true)}
                                          dangerouslySetInnerHTML={{__html: candidate.basic.fullname}}></span>
                                </h3>
                            </div>
                            <div className="user_designation">
                                {candidate?.basic?.current_title && <span className="rp_current_role"
                                                                          dangerouslySetInnerHTML={{__html: (candidate?.basic?.current_title)}}></span>}
                                {/*{candidate?.basic?.current_title &&
                                    <>
                                        <span className="rp_text">@</span>
                                        <span className="rp_company">{candidate?.basic?.current_title}</span>
                                    </>
                                }*/}

                                {candidate?.currentPosition?.c_seniority &&
                                    <span className="rp_tags hide_rp_tag_mob ml-1">
                                        <span className="dot"></span>
                                        <span className="rp_tag_text">{candidate?.currentPosition?.c_seniority}</span>
                                    </span>}
                            </div>
                            {/*<h4>{candidate.basic.current_title} at {candidate.basic.current}</h4>*/}
                            <div className="user_address">{candidate?.basic?.location}</div>
                            {/*<div className="perfomance_row">
                                <p>Likely to Switch</p>
                                <ul>
                                    {[1, 2, 3, 4, 5].map((i) => <li key={i}
                                                                    className={(candidate.recruitplus.availability_score ?? 0) < i ? '' : 'active'}></li>)}
                                </ul>
                                <span>{candidate.recruitplus.availability_level ?? ''}</span>
                            </div>*/}
                        </div>
                    </div>
                </div>
                <div className="user_other_info">
                    {/*<ul className="usr_info mt-0 likely_ul">*/}
                    {/*    <li>*/}
                    {/*        <div className="text-end">*/}
                    {/*            <img className="likely_svg"*/}
                    {/*                 src={`${process.env.PUBLIC_URL}/assets/images/likely-to-respond.svg`}*/}
                    {/*                 alt="Likely to Respond"/>*/}
                    {/*        </div>*/}
                    {/*        <div className="rt_con social_bar">*/}
                    {/*            <div>*/}
                    {/*                <div className="perfomance_row">*/}
                    {/*                    <p>Likely to Respond</p>*/}
                    {/*                    <ul>*/}
                    {/*                        {[1, 3, 5, 8, 10].map((i) => <li key={i}*/}
                    {/*                                                         className={availabilityScore < i ? '' : 'active'}></li>)}*/}

                    {/*                    </ul>*/}
                    {/*                    <span>{availabilityVal}</span>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </li>*/}
                    {/*</ul>*/}
                    <ul className="usr_info">
                        {user?.abUser && emailData?.length > 0 && !authUser?.plan_expire_reminder &&
                            <li>
                                <div className="lt_icon">
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M22 6.5C22 5.4 21.1 4.5 20 4.5H4C2.9 4.5 2 5.4 2 6.5V18.5C2 19.6 2.9 20.5 4 20.5H20C21.1 20.5 22 19.6 22 18.5V6.5ZM20 6.5L12 11.5L4 6.5H20ZM20 18.5H4V8.5L12 13.5L20 8.5V18.5Z"
                                            fill="#65676B"/>
                                        <path
                                            d="M22 6.5C22 5.4 21.1 4.5 20 4.5H4C2.9 4.5 2 5.4 2 6.5V18.5C2 19.6 2.9 20.5 4 20.5H20C21.1 20.5 22 19.6 22 18.5V6.5ZM20 6.5L12 11.5L4 6.5H20ZM20 18.5H4V8.5L12 13.5L20 8.5V18.5Z"
                                            fill="black" fillOpacity="0.5"/>
                                    </svg>
                                    <span>Email</span>
                                </div>
                                <div className="rt_con">
                                    <div className="add_cd">
                                        {emailData?.length > 0 && emailData}
                                        {queryEnabled && <img src={loader}/>}
                                        {!emailData.length && !queryEnabled &&
                                            <a>{candidate?.basic?.fullname && candidate?.basic?.fullname.replace(/(<([^>]+)>)/ig, '')[0].toLowerCase()}*******@*****.com</a>
                                        }
                                        {handleShow.AddEmail && <div className="drop_down_parent">
                                            <ValidationGroup>
                                                <form className="dorpdown_selectarea"
                                                      onSubmit={(event) => addCandidateDetailsFunc(event, 'saveCandidateEmail')}>
                                                    <div className="left_box">
                                                        <InputField
                                                            variant="standard"
                                                            required={[true, 'Please enter email']}
                                                            type="email"
                                                            name="email"
                                                            classes={{root: 'lable_error_class'}}
                                                            value={newCandidateDetails.email}
                                                            placeholder="Add an email address"
                                                            customValidation={[(value) => !isOnlyWhiteSpace(value), 'Please enter email']}
                                                            onChange={handleChange}
                                                        />
                                                        <div className="right_box">
                                                            <AutoDisabler firstDisplayErrors={true}>
                                                                <InputButton
                                                                    className='btn btn_fill btn_small_1'
                                                                    type="submit"
                                                                    isLoading={addCandidateDetailsAPI.isLoading}>
                                                                    Save
                                                                </InputButton>
                                                            </AutoDisabler>
                                                            <button className="btn btn_outline btn_small_2"
                                                                    onClick={() => {
                                                                        setHandleShow(prevState => ({
                                                                            ...prevState,
                                                                            AddEmail: false,
                                                                            AddPhone: false
                                                                        }))
                                                                        setCandidateDetails(prevState => ({
                                                                            ...prevState,
                                                                            emailType: '',
                                                                            email: '',
                                                                            phoneType: '',
                                                                            phone: ''
                                                                        }))
                                                                    }}>Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </ValidationGroup>
                                        </div>}

                                    </div>
                                </div>
                            </li>
                        }
                        {user?.abUser && phoneData?.length > 0 && !authUser?.plan_expire_reminder &&
                            <li>
                                <div className="lt_icon">
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.83317 21.6666C7.37484 21.6666 6.98261 21.5036 6.6565 21.1775C6.32984 20.8508 6.1665 20.4583 6.1665 20V4.99998C6.1665 4.54165 6.32984 4.14915 6.6565 3.82248C6.98261 3.49637 7.37484 3.33331 7.83317 3.33331H16.1665C16.6248 3.33331 17.0173 3.49637 17.344 3.82248C17.6701 4.14915 17.8332 4.54165 17.8332 4.99998V20C17.8332 20.4583 17.6701 20.8508 17.344 21.1775C17.0173 21.5036 16.6248 21.6666 16.1665 21.6666H7.83317ZM7.83317 17.5V20H16.1665V17.5H7.83317ZM11.9998 19.5833C12.2359 19.5833 12.434 19.5033 12.594 19.3433C12.7534 19.1839 12.8332 18.9861 12.8332 18.75C12.8332 18.5139 12.7534 18.3161 12.594 18.1566C12.434 17.9966 12.2359 17.9166 11.9998 17.9166C11.7637 17.9166 11.5659 17.9966 11.4065 18.1566C11.2465 18.3161 11.1665 18.5139 11.1665 18.75C11.1665 18.9861 11.2465 19.1839 11.4065 19.3433C11.5659 19.5033 11.7637 19.5833 11.9998 19.5833ZM7.83317 15.8333H16.1665V7.49998H7.83317V15.8333ZM7.83317 5.83331H16.1665V4.99998H7.83317V5.83331Z"
                                            fill="#65676B"/>
                                        <path
                                            d="M7.83317 21.6666C7.37484 21.6666 6.98261 21.5036 6.6565 21.1775C6.32984 20.8508 6.1665 20.4583 6.1665 20V4.99998C6.1665 4.54165 6.32984 4.14915 6.6565 3.82248C6.98261 3.49637 7.37484 3.33331 7.83317 3.33331H16.1665C16.6248 3.33331 17.0173 3.49637 17.344 3.82248C17.6701 4.14915 17.8332 4.54165 17.8332 4.99998V20C17.8332 20.4583 17.6701 20.8508 17.344 21.1775C17.0173 21.5036 16.6248 21.6666 16.1665 21.6666H7.83317ZM7.83317 17.5V20H16.1665V17.5H7.83317ZM11.9998 19.5833C12.2359 19.5833 12.434 19.5033 12.594 19.3433C12.7534 19.1839 12.8332 18.9861 12.8332 18.75C12.8332 18.5139 12.7534 18.3161 12.594 18.1566C12.434 17.9966 12.2359 17.9166 11.9998 17.9166C11.7637 17.9166 11.5659 17.9966 11.4065 18.1566C11.2465 18.3161 11.1665 18.5139 11.1665 18.75C11.1665 18.9861 11.2465 19.1839 11.4065 19.3433C11.5659 19.5033 11.7637 19.5833 11.9998 19.5833ZM7.83317 15.8333H16.1665V7.49998H7.83317V15.8333ZM7.83317 5.83331H16.1665V4.99998H7.83317V5.83331Z"
                                            fill="black" fillOpacity="0.5"/>
                                    </svg>
                                    <span>Phone</span>
                                </div>
                                <div className="rt_con">
                                    <div className="add_cd">
                                        {phoneData?.length > 0 && phoneData}
                                        {queryEnabled && <img src={loader}/>}
                                        {!phoneData.length && !queryEnabled &&
                                            <a>98-9****-***</a>
                                        }
                                        {handleShow.AddPhone && <div className="drop_down_parent">
                                            <ValidationGroup>
                                                <form className="dorpdown_selectarea"
                                                      onSubmit={(event) => addCandidateDetailsFunc(event, 'saveCandidatePhone')}>
                                                    <div className="left_box">
                                                        <InputField
                                                            variant="standard"
                                                            required={[true, 'Please enter number']}
                                                            type="number"
                                                            name="phone"
                                                            value={newCandidateDetails.phone}
                                                            classes={{root: "lable_error_class"}}
                                                            placeholder="Add phone number"
                                                            customValidation={[(value) => !isOnlyWhiteSpace(value), 'Please enter number']}
                                                            onChange={handleChange}
                                                        />
                                                        <div className="right_box">
                                                            <AutoDisabler firstDisplayErrors={true}>
                                                                <InputButton
                                                                    className='btn btn_fill btn_small_1'
                                                                    type="submit"
                                                                    isLoading={addCandidateDetailsAPI.isLoading}>
                                                                    Save
                                                                </InputButton>
                                                            </AutoDisabler>
                                                            <button className="btn btn_outline btn_small_2"
                                                                    onClick={() => {
                                                                        setHandleShow(prevState => ({
                                                                            ...prevState,
                                                                            AddEmail: false,
                                                                            AddPhone: false
                                                                        }))
                                                                        setCandidateDetails(prevState => ({
                                                                            ...prevState,
                                                                            emailType: '',
                                                                            email: '',
                                                                            phoneType: '',
                                                                            phone: ''
                                                                        }))
                                                                    }}>Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </ValidationGroup>
                                        </div>}
                                    </div>
                                </div>
                            </li>
                        }
                        {user?.abUser && accurate &&
                            <li>
                                <div className="lt_icon">
                                    <svg width="24" height="24" viewBox="0 0 123 123" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M52.01 110.22C42.05 108.31 33.15 103.43 26.25 96.54C19.35 89.64 14.48 80.74 12.57 70.77H18.78C20.6 79.05 24.77 86.45 30.56 92.24C36.34 98.02 43.74 102.19 52.02 104.02V110.22H52.01ZM96.31 64.48C94.63 64.48 93.27 63.12 93.27 61.44C93.27 59.76 94.63 58.4 96.31 58.4H119.83C121.51 58.4 122.87 59.76 122.87 61.44C122.87 63.12 121.51 64.48 119.83 64.48H96.31ZM64.48 26.57C64.48 28.25 63.12 29.61 61.44 29.61C59.76 29.61 58.4 28.25 58.4 26.57V3.04C58.4 1.36 59.76 0 61.44 0C63.12 0 64.48 1.36 64.48 3.04V26.57ZM64.48 119.84C64.48 121.52 63.12 122.88 61.44 122.88C59.76 122.88 58.4 121.52 58.4 119.84V96.31C58.4 92.31 64.48 92.31 64.48 96.31V119.84ZM3.04 64.48C1.36 64.48 0 63.12 0 61.44C0 59.76 1.36 58.4 3.04 58.4H26.56C28.24 58.4 29.6 59.76 29.6 61.44C29.6 63.12 28.24 64.48 26.56 64.48H3.04ZM61.43 46.94C69.44 46.94 75.93 53.43 75.93 61.44C75.93 69.45 69.44 75.94 61.43 75.94C53.42 75.94 46.93 69.45 46.93 61.44C46.94 53.43 53.43 46.94 61.43 46.94ZM12.56 51.92C14.47 41.96 19.35 33.06 26.24 26.16C33.14 19.26 42.04 14.38 52.01 12.47V18.69C43.73 20.51 36.33 24.68 30.54 30.47C24.76 36.25 20.58 43.64 18.77 51.92H12.56ZM70.86 12.46C80.83 14.37 89.73 19.25 96.63 26.15C103.53 33.04 108.41 41.96 110.31 51.92H104.1C102.28 43.64 98.11 36.23 92.32 30.45C86.54 24.66 79.14 20.49 70.86 18.67V12.46ZM110.32 70.77C108.41 80.73 103.53 89.64 96.63 96.54C89.73 103.44 80.83 108.32 70.86 110.23V104.02C87.41 100.38 100.48 87.33 104.11 70.77H110.32Z"
                                            fill="black"/>
                                    </svg>
                                    <span className="accuracy_text">Accuracy</span>
                                </div>
                                <div className="rt_con">
                                    <div className="add_cd">
                                        <span>{accurate} %</span>
                                    </div>
                                </div>
                            </li>
                        }
                        <li>
                            <div className="lt_icon">
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.74292 13.9804L15.9238 18.0196M15.9238 7.98042L8.74292 12.0196M9 13C9 14.1046 8.10457 15 7 15C5.89543 15 5 14.1046 5 13C5 11.8954 5.89543 11 7 11C8.10457 11 9 11.8954 9 13ZM19.6667 7C19.6667 8.10457 18.7712 9 17.6667 9C16.5621 9 15.6667 8.10457 15.6667 7C15.6667 5.89543 16.5621 5 17.6667 5C18.7712 5 19.6667 5.89543 19.6667 7ZM19.6667 19C19.6667 20.1046 18.7712 21 17.6667 21C16.5621 21 15.6667 20.1046 15.6667 19C15.6667 17.8954 16.5621 17 17.6667 17C18.7712 17 19.6667 17.8954 19.6667 19Z"
                                        stroke="#65676B" strokeWidth="1.5" strokeLinecap="round"
                                        strokeLinejoin="round"/>
                                    <path
                                        d="M8.74292 13.9804L15.9238 18.0196M15.9238 7.98042L8.74292 12.0196M9 13C9 14.1046 8.10457 15 7 15C5.89543 15 5 14.1046 5 13C5 11.8954 5.89543 11 7 11C8.10457 11 9 11.8954 9 13ZM19.6667 7C19.6667 8.10457 18.7712 9 17.6667 9C16.5621 9 15.6667 8.10457 15.6667 7C15.6667 5.89543 16.5621 5 17.6667 5C18.7712 5 19.6667 5.89543 19.6667 7ZM19.6667 19C19.6667 20.1046 18.7712 21 17.6667 21C16.5621 21 15.6667 20.1046 15.6667 19C15.6667 17.8954 16.5621 17 17.6667 17C18.7712 17 19.6667 17.8954 19.6667 19Z"
                                        stroke="black" strokeOpacity="0.5" strokeWidth="1.5" strokeLinecap="round"
                                        strokeLinejoin="round"/>
                                </svg>
                                <span>Socials</span>
                            </div>
                            <div className="rt_con social_bar icon-size">
                                <ul>
                                    {formatSocialLinks((candidate?.basic?.social_links ?? candidate?.basic?.socialLinks), candidate)}
                                </ul>
                            </div>
                        </li>
                        {candidateInProject.length > 0 && <li>
                            <div className="lt_icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="24"
                                     height="25">
                                    <path
                                        d="M 20 2 A 1 1 0 0 0 19 3 L 19 5 L 9 5 A 1 1 0 0 0 8 6 L 8 57 A 1 1 0 0 0 9 58 L 49 58 L 49 56 L 10 56 L 10 7 L 19 7 L 19 9 A 1 1 0 0 0 20 10 L 43 10 A 1 1 0 0 0 44 9 L 44 7 L 54 7 L 54 46 L 56 46 L 56 6 A 1 1 0 0 0 55 5 L 44 5 L 44 3 A 1 1 0 0 0 43 2 L 20 2 z M 21 4 L 42 4 L 42 8 L 21 8 L 21 4 z M 15 14 L 15 16 L 49 16 L 49 14 L 15 14 z M 15 20 L 15 22 L 37 22 L 37 20 L 15 20 z M 37.919922 25.3125 A 13.028 13.028 0 1 0 46.650391 48.236328 L 49.515625 51.099609 L 48.808594 51.806641 A 1 1 0 0 0 48.808594 53.220703 L 57.292969 61.705078 A 1 1 0 0 0 58.707031 61.705078 L 61.535156 58.878906 A 1 1 0 0 0 61.535156 57.464844 L 53.050781 48.978516 A 1 1 0 0 0 51.636719 48.978516 L 50.929688 49.685547 L 48.066406 46.822266 A 13.028 13.028 0 0 0 37.919922 25.3125 z M 15 26 L 15 28 L 26 28 L 26 26 L 15 26 z M 37.902344 27.376953 A 11 11 0 0 1 49.199219 38.371094 A 10.921 10.921 0 0 1 45.978516 46.150391 A 11 11 0 1 1 37.902344 27.376953 z M 36.912109 29.373047 A 1.789 1.789 0 0 0 35.111328 31.140625 L 35.111328 31.488281 A 7.914 7.914 0 0 0 33.558594 32.355469 L 33.181641 32.148438 A 1.834 1.834 0 0 0 30.746094 32.789062 L 29.455078 34.923828 A 1.727 1.727 0 0 0 29.263672 36.271484 A 1.785 1.785 0 0 0 30.121094 37.363281 L 30.453125 37.546875 A 7.1 7.1 0 0 0 30.404297 38.373047 A 7.266 7.266 0 0 0 30.453125 39.197266 L 30.123047 39.382812 A 1.783 1.783 0 0 0 29.263672 40.472656 A 1.723 1.723 0 0 0 29.457031 41.822266 L 30.744141 43.955078 A 1.84 1.84 0 0 0 33.183594 44.597656 L 33.558594 44.388672 A 7.881 7.881 0 0 0 35.111328 45.255859 L 35.111328 45.599609 A 1.789 1.789 0 0 0 36.912109 47.369141 L 39.488281 47.369141 A 1.789 1.789 0 0 0 41.289062 45.599609 L 41.289062 45.251953 A 7.919 7.919 0 0 0 42.84375 44.384766 L 43.220703 44.591797 A 1.832 1.832 0 0 0 45.65625 43.951172 L 46.943359 41.820312 A 1.722 1.722 0 0 0 47.138672 40.470703 A 1.777 1.777 0 0 0 46.283203 39.382812 L 45.953125 39.197266 A 7.122 7.122 0 0 0 45.953125 37.546875 L 46.28125 37.363281 A 1.78 1.78 0 0 0 47.142578 36.271484 A 1.72 1.72 0 0 0 46.949219 34.923828 L 45.660156 32.789062 A 1.834 1.834 0 0 0 43.224609 32.148438 L 42.847656 32.355469 A 7.988 7.988 0 0 0 41.292969 31.488281 L 41.292969 31.140625 A 1.789 1.789 0 0 0 39.492188 29.373047 L 36.912109 29.373047 z M 37.103516 31.373047 L 39.289062 31.373047 L 39.289062 31.654297 A 1.786 1.786 0 0 0 40.445312 33.300781 A 5.835 5.835 0 0 1 41.730469 34.015625 A 1.869 1.869 0 0 0 43.720703 34.15625 L 44.044922 33.976562 L 45.099609 35.730469 L 44.851562 35.869141 A 1.754 1.754 0 0 0 43.945312 37.634766 A 5.128 5.128 0 0 1 44 38.373047 A 5.149 5.149 0 0 1 43.945312 39.111328 A 1.75 1.75 0 0 0 44.845703 40.873047 L 45.099609 41.013672 L 44.041016 42.765625 L 43.716797 42.585938 A 1.867 1.867 0 0 0 41.726562 42.728516 A 5.762 5.762 0 0 1 40.441406 43.441406 A 1.789 1.789 0 0 0 39.289062 45.089844 L 39.289062 45.373047 L 37.107422 45.373047 L 37.107422 45.089844 A 1.788 1.788 0 0 0 35.955078 43.441406 A 5.8 5.8 0 0 1 34.671875 42.728516 A 1.855 1.855 0 0 0 32.683594 42.585938 L 32.357422 42.765625 L 31.300781 41.013672 L 31.548828 40.875 A 1.754 1.754 0 0 0 32.449219 39.107422 A 5.1 5.1 0 0 1 32.449219 37.634766 A 1.754 1.754 0 0 0 31.548828 35.871094 L 31.296875 35.730469 L 32.353516 33.980469 L 32.677734 34.158203 A 1.861 1.861 0 0 0 34.669922 34.015625 A 5.848 5.848 0 0 1 35.953125 33.304688 A 1.788 1.788 0 0 0 37.103516 31.654297 L 37.103516 31.373047 z M 16 32 A 1 1 0 0 0 15 33 L 15 39 A 1 1 0 0 0 16 40 L 22 40 A 1 1 0 0 0 23 39 L 23 33 A 1 1 0 0 0 22 32 L 16 32 z M 17 34 L 21 34 L 21 38 L 17 38 L 17 34 z M 38.199219 34.373047 A 4 4 0 1 0 42.199219 38.373047 A 4 4 0 0 0 38.199219 34.373047 z M 38.117188 36.375 A 2 2 0 0 1 40.199219 38.373047 A 2 2 0 0 1 38.199219 40.373047 A 2 2 0 0 1 38.117188 36.375 z M 15 44 L 15 46 L 23 46 L 23 44 L 15 44 z M 15 50 L 15 52 L 27 52 L 27 50 L 15 50 z M 52.34375 51.099609 L 59.414062 58.171875 L 58 59.585938 L 50.929688 52.515625 L 52.34375 51.099609 z"/>
                                </svg>
                                <span>Projects</span>
                            </div>

                            <div className="rt_con social_bar cp_details">
                                <ul>
                                    <li>
                                        {candidateInProject}
                                    </li>
                                </ul>
                            </div>
                        </li>}

                    </ul>
                    <div className={`user_right ${(isLoading || isRefetching) ? `show_dp` : ``}`}>
                        {/*{state.showComponent === 'success' && (<>*/}
                        {/*    <div className="rp-checked-message">*/}
                        {/*        <ion-icon name="checkmark"></ion-icon>*/}
                        {/*        1 Candidate Saved to Pipeline successfully*/}
                        {/*    </div>*/}
                        {/*</>)}*/}
                        {/*{state.showComponent === 'error' && (<>*/}
                        {/*    <div className="rp-checked-message">*/}
                        {/*        {state.error && <div className="form-error">*/}
                        {/*            <ion-icon name="alert"></ion-icon>*/}
                        {/*            <span>{state.error}</span>*/}
                        {/*        </div>}*/}
                        {/*    </div>*/}
                        {/*</>)}*/}
                        {user?.abUser ? <InputButton
                            disabled={disableCandidateEmailAndPhoneBtn}
                            className='btn btn_fill btn_sm'
                            onClick={(e) => getPhoneAndEmail(e)}
                            isLoading={queryEnabled}>
                            Get Email & Phone
                        </InputButton> : <InputButton
                            className='btn btn_fill btn_sm'
                            onClick={() => openLinkedIn(candidate)}>
                            Connect via Linkedin
                        </InputButton>}

                        {props?.network?.forPipeline && <InputButton
                            className="btn btn_outline btn_sm"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={() => setDeleteModalOpen(true)}
                        >Remove From Pipeline
                        </InputButton>}
                        {!props?.network?.forPipeline && (props.fullPage || project_id) && <InputButton
                            className="btn btn_outline btn_sm"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={() => saveToPipeline()}
                            isLoading={addCandidateAPI.isLoading}
                        >Save to Pipeline
                        </InputButton>}
                        <button className="btn btn_outline btn_sm" onClick={() => {
                            similarProfile()
                        }}>Similar Profiles
                        </button>

                        <div className="min_width">
                            <InputButton
                                className="btn btn_outline btn_sm"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                onClick={() => {
                                    refetch()
                                    getGATrackofDetails("Download Profile")
                                }}
                                isLoading={isLoading || isRefetching}
                            >Download Profile
                            </InputButton>
                            {(isLoading || isRefetching) && <>
                                <div className="down_profile">
                                    Downloading profile..
                                </div>
                            </>}
                        </div>
                        {/*<button className="btn save_btn btn_fill" onClick={openJsonPopupFun('pipeline')}>Save to Pipeline</button>*/}
                    </div>
                    {getCandidateEmailAndPhoneAPI?.data?.retry && queryEnabled &&
                        <p>{getCandidateEmailAndPhoneAPI?.data?.message}</p>}
                </div>
            </div>
            {candidate.basic.highlight && <div className="mb_10 about_section">
                <div className="content">
                    <div className="sub_title">
                        <h2>Highlights</h2>
                        <ReadMore size={300} text={candidate?.basic?.highlight}/>
                    </div>
                </div>
            </div>}
            {Object.keys(companyArrangedList).length > 0 && <div className="mb_10 experience_section">
                <div className="content">
                    <div className="sub_title">
                        <h2>Experience ({fullTimeYearsText})</h2>
                    </div>
                    {!isMobile &&
                        <div className="timelineh">
                            <Timeline timeLineData={candidate?.timeline}/>
                        </div>}
                    <div className="exp_list_row">
                        {positionsArr}
                        {Object.keys(companyArrangedList).length > 2 && <div className="text-start">
                            <button className="show_more_btn mt-0" onClick={() => {
                                setHandleShow(prevState => ({
                                    ...prevState, allExperiences: !prevState.allExperiences
                                }))
                            }}>{handleShow.allExperiences ? "Show less" : "Show all"}</button>
                        </div>}
                    </div>
                </div>
            </div>}
            {candidate?.educations?.length > 0 && <div className="mb_10 eduction_section">
                <div className="content">
                    <div className="sub_title">
                        <h2>Education ({candidate?.educations?.length})</h2>
                    </div>
                    <div className="edu_list">
                        <ul>
                            {qualificationsArr}
                        </ul>
                        {candidate?.educations?.length > 2 && <div className="text-start">
                            <button className="show_more_btn mt-0" onClick={() => {
                                setHandleShow(prevState => ({
                                    ...prevState, allEducations: !prevState.allEducations
                                }))
                            }}>{handleShow.allEducations ? "Show less" : "Show all"}</button>
                        </div>}
                    </div>
                </div>
            </div>}
            {candidate?.kaggle && <div className="mb_10 kagle_section">
                <div className="content">
                    <div className="sub_title">
                        <h2>Kaggle</h2>
                    </div>
                    <div className="kaggle_details">
                        <div className="kaggle_list">
                            {candidate?.kaggle?.tier && <div className="content_list mb_3">
                                <div><h6>Tier</h6></div>
                                <div><p>{candidate?.kaggle?.tier}</p></div>
                            </div>}
                            <div className="content_list mb_3">
                                <div><h6>Medals</h6></div>
                                <div className="meadal_column">
                                    {candidate?.kaggle?.medals && candidate?.kaggle?.medals.map(({total, name}, i) => {
                                        return <span key={i}>
                                            {i > 0 && <span className="dot black"></span>}
                                            <span className="text_1">{total} </span>
                                            <span className="text_2">{name}</span>
                                        </span>
                                    })}
                                </div>
                            </div>
                            <div className="content_list mb_3">
                                <div><h6>Upvotes</h6></div>
                                <div><p>{candidate?.kaggle?.up_votes}</p></div>
                            </div>
                            <div className="content_list mb_10">
                                <div><h6>Followers</h6></div>
                                <div><p>{candidate?.kaggle?.followers}</p></div>
                            </div>
                            {candidate?.kaggle_profile?.datasets && <div className="content_list mb_20">
                                <div className="l_content">
                                    <h6>Datasets</h6>
                                </div>
                                <div className="r_content">
                                    <div className="user_designation">
                                        {candidate?.kaggle_profile?.datasets.slice(0, handleShow.allDataset ? undefined : 3).map(({
                                                                                                                                      title,
                                                                                                                                      ref
                                                                                                                                  }, i) => {
                                            return <><span className="rp_user_text1" key={i}><a
                                                href={`https://www.kaggle.com/datasets/${ref}`} target="_blank"
                                                rel="noreferrer">{title}</a></span></>
                                        })}
                                    </div>
                                    {candidate?.kaggle_profile?.datasets?.length > 3 && <div className="text-start">
                                        <button className="show_more_btn mt-0" onClick={() => {
                                            setHandleShow(prevState => ({
                                                ...prevState, allDataset: !prevState.allDataset
                                            }))
                                        }}>{handleShow.allDataset ? "Show less" : "Show all"}</button>
                                    </div>}
                                </div>
                            </div>}
                            {candidate?.kaggle_profile?.kernels && <div className="kaggle_row">
                                {candidate?.kaggle_profile?.kernels.slice(0, handleShow.allKernels ? undefined : 3).map(({
                                                                                                                             title,
                                                                                                                             language,
                                                                                                                             totalVotes,
                                                                                                                             ref
                                                                                                                         }, i) =>
                                    <div className="content_list">
                                        <div className="l_content">
                                            {i === 0 && <h6>Kernels</h6>}
                                        </div>
                                        <div className="r_content">
                                            <div className="user_designation">
                                                <a href={`https://www.kaggle.com/code/${ref}`} target="_blank"
                                                   rel="noreferrer"><p className="rp_user_text1">{title}</p></a>
                                            </div>
                                            <div className="kernels_row">
                                                <table className="rsptable">
                                                    <thead>
                                                    <tr>
                                                        <th>Language</th>
                                                        <th>Votes</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td>{language}</td>
                                                        <td>{totalVotes}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>)}
                                {candidate?.kaggle_profile?.kernels.length > 3 && <div className="content_list">
                                    <div className="l_content">
                                    </div>
                                    <div className="text-start">
                                        <button className="show_more_btn mt-0" onClick={() => {
                                            setHandleShow(prevState => ({
                                                ...prevState, allKernels: !prevState.allKernels
                                            }))
                                        }}>{handleShow.allKernels ? "Show less" : "Show all"}</button>
                                    </div>
                                </div>}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>

            }
            {candidate.recruitplus.calculated_skills.length > 0 && <div className="mb_10 skill_section">
                <div className="content">
                    <div className="sub_title mb_15">
                        <h2>Skills ({candidate.recruitplus.calculated_skills.length})</h2>
                    </div>
                    <div className="inline_pills">
                        <ul>
                            {candidate.recruitplus.calculated_skills.slice(0, handleShow.allSkills ? undefined : 5).map((skill) => {
                                if (skill.name) {
                                    return <li key={skill.name}>
                                        <span dangerouslySetInnerHTML={{__html: skill.name}}></span>
                                    </li>
                                }
                            })}
                        </ul>
                        {candidate.recruitplus?.calculated_skills.length > 5 &&
                            <div className="text-start" onClick={() => {
                                setHandleShow(prevState => ({...prevState, allSkills: !prevState.allSkills}))
                            }}>
                                <button
                                    className="show_more_btn mt-0">{handleShow.allSkills ? "Show less" : "Show all"}</button>
                            </div>}
                    </div>
                </div>
            </div>}
            {/*{candidate.analytics?.focus?.length > 0 && <div className="mb_10 skill_section">*/}
            {/*    <div className="content">*/}
            {/*        <div className="sub_title mb_15">*/}
            {/*            <h2>Focus ({candidate.analytics?.focus?.length})</h2>*/}
            {/*        </div>*/}
            {/*        <div className="inline_pills">*/}
            {/*            <ul>*/}
            {/*                {candidate.analytics?.focus && candidate.analytics.focus.slice(0, handleShow.allFocus ? undefined : 5).map((focus) => {*/}
            {/*                    if (focus) {*/}
            {/*                        return <li key={focus}>*/}
            {/*                            {focus}*/}
            {/*                        </li>*/}
            {/*                    }*/}
            {/*                })}*/}
            {/*            </ul>*/}
            {/*            {candidate.analytics?.focus?.length > 5 && <div className="text-start" onClick={() => {*/}
            {/*                setHandleShow(prevState => ({...prevState, allFocus: !prevState.allFocus}))*/}
            {/*            }}>*/}
            {/*                <button*/}
            {/*                    className="show_more_btn mt-0">{handleShow.allFocus ? "less" : "Show all"}</button>*/}
            {/*            </div>}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>}*/}
            {candidate?.coffeemug && <div className="mb_10 insight_section">
                <div className="content">
                    <div className="sub_title">
                        <h2>CoffeeMug Insights</h2>
                    </div>
                    {candidate?.coffeemug?.persona?.title && <div className="grid_style inline_row mb_26">
                        <div><h3>Networking Persona</h3></div>
                        <ul className="networking_pills">
                            {createPersonaData(candidate?.coffeemug?.persona)}
                        </ul>
                    </div>}
                    <div className="grid_style inline_pills strong_pills inline_row mb_17">
                        <div><h3>Popularity</h3></div>
                        <div className="text_style">
                            <h6>Popular</h6>
                            {candidate?.coffeemug?.endorsement > 0 &&
                                <p>Endorsed by {candidate?.coffeemug?.endorsement} members</p>}
                        </div>
                    </div>
                    {candidate.coffeemug.objectives.length > 0 &&
                        <div className="grid_style inline_pills inline_row strong_pills mb_26">
                            <div><h3>Interested in</h3></div>
                            <div>
                                {candidate.coffeemug.objectives.length > 0 &&
                                    <div key="objective" className="user_features">
                                        <ul className="skills-li">
                                            {candidate.coffeemug.objectives.map(obj => {
                                                return <li key={nanoid(5)} className="skills-li"><span>{obj}</span>
                                                </li>
                                            })}
                                        </ul>
                                    </div>}
                                {candidate.recruitplus.coffeemug.job_role && <div key="job" className="user_features">
                                    <p>Job Interest</p>
                                    <ul className="skills-li">
                                        <li>{candidate.recruitplus.coffeemug.job_role} at</li>
                                        <li className="border_class">
                                            <span>{candidate.recruitplus.coffeemug.job_stage}</span></li>
                                    </ul>
                                </div>}
                            </div>
                        </div>}
                    {(candidate?.coffeemug?.role_interest.length > 0 || candidate?.coffeemug?.industry_interest.length > 0) &&
                        <div className="grid_style inline_row">
                            <div><h3>Meeting Preferences</h3></div>
                            <div className="inline_pills strong_pills text_style">
                                {candidate?.coffeemug?.role_interest && <div className="metting_col">
                                    <p>Roles of interest</p>
                                    <ul>
                                        {candidate?.coffeemug?.role_interest?.filter(row => row && row.trim() && !row.includes(['-']))?.map(obj => {
                                            return <li key={nanoid(5)} className="skills-li"><span>{obj}</span>
                                            </li>
                                        })}
                                    </ul>
                                </div>}
                                {candidate?.coffeemug?.industry_interest && <div className="metting_col">
                                    <p>Industries of interest</p>
                                    <div className="text_style">
                                        <div className="inline_pills">
                                            <ul>
                                                {candidate?.coffeemug?.industry_interest.map(obj => {
                                                    return <li key={nanoid(5)} className="skills-li">
                                                        <span>{obj}</span>
                                                    </li>
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>}
                </div>
            </div>}
        </>

        githubAndSimilar = <>
            {github && <div>
                <div className="author_info sidebar_container">
                    <div id="accordion">
                        {props.network?.forGithub && <>
                            <div className="git_title">
                                <h3 className="author_title">GitHub</h3>
                            </div>

                            <div className="collapse_row_1 sidebar_row mb_10">
                                <ul>
                                    <li className="rp-git-lang">
                                        <h4>Coder Score</h4>
                                        <div className="star">
                                            <span>{candidate?.other_sources?.github?.profile_rank}</span>
                                            <ul className="rating_icons">
                                                {Array(Math.floor(candidate?.other_sources?.github?.profile_rank)).fill(1).map((i, j) => (
                                                    <li className="active" key={`full-${j}`}>
                                                        <ion-icon name="star"></ion-icon>
                                                    </li>))}
                                                {Array(5 - Math.floor(candidate?.other_sources?.github?.profile_rank)).fill(1).map((i, j) => {
                                                    if (candidate?.other_sources?.github?.profile_rank % 1 !== 0 && j === 0) {
                                                        return <li className="not_active" key={`half-${j}`}>
                                                            <ion-icon name="star-half-outline"
                                                                      className="empty_value"></ion-icon>
                                                        </li>
                                                    } else {
                                                        return <li className="not_active" key={`blank-${j}`}>
                                                            <ion-icon name="star-outline"
                                                                      className="empty_value"></ion-icon>
                                                        </li>
                                                    }

                                                })}
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="collapse_row_2 sidebar_row mb_10">
                                <h4>Languages ({languageSortedByRating.length})</h4>
                                <ul>
                                    {languageSortedByRating.length > 0 && languageSortedByRating.slice(0, handleShow.allLanguages ? undefined : 5).map((language, key) => (
                                        <li className="rp-git-lang" key={key}>
                                            <span>{capitalizeFirst(language.lang)}</span>
                                            <div className="star">
                                                <span>{language.rating}</span>
                                                <ul className="rating_icons">
                                                    {Array(Math.floor(language.rating)).fill(1).map((i, j) => (
                                                        <li className="active" key={`active-${j}`}>
                                                            <ion-icon name="star"></ion-icon>
                                                        </li>))}
                                                    {Array(5 - Math.floor(language.rating)).fill(1).map((i, j) => {
                                                        if (language.rating % 1 !== 0 && j === 0) {
                                                            return <li className="not_active" key={`halfActive-${j}`}>
                                                                <ion-icon name="star-half-outline"
                                                                          className="empty_value"></ion-icon>
                                                            </li>
                                                        } else {
                                                            return <li className="not_active" key={`notActive-${j}`}>
                                                                <ion-icon name="star-outline"
                                                                          className="empty_value"></ion-icon>
                                                            </li>
                                                        }

                                                    })}
                                                </ul>
                                            </div>
                                        </li>))}
                                </ul>
                                {languageSortedByRating.length > 5 && <button className="show_more_btn" onClick={() => {
                                    setHandleShow(prevState => ({
                                        ...prevState, allLanguages: !prevState.allLanguages
                                    }))
                                }}>{handleShow.allLanguages ? "Show less" : "Show all"}</button>}
                            </div>

                            <div className="collapse_row_3 sidebar_row mb_10">
                                <h4>Repositories ({github?.repos?.length})</h4>
                                <div className="collapse_layout" key='githubCandidate'>
                                    <ul>
                                        {sortedRepos.length > 0 && sortedRepos.slice(0, handleShow.allRepos ? undefined : 5).map((repo, i) => (
                                            <li key={i}>
                                                <a href={repo?.url}
                                                   target="_blank"
                                                   rel="noreferrer"
                                                   title={repo?.name}>{repo?.name}</a>
                                                <span>{repo?.languages?.map((language, key) => (<>{capitalizeFirst(language?.lang + ' ')}</>))}</span>
                                            </li>))}
                                    </ul>
                                </div>
                                {sortedRepos.length > 5 && <button className="show_more_btn" onClick={() => {
                                    setHandleShow(prevState => ({
                                        ...prevState, allRepos: !prevState.allRepos
                                    }))
                                }}>{handleShow.allRepos ? "Show less" : "Show all"}</button>}
                            </div>
                        </>}
                        {similarDiv}
                    </div>
                </div>
            </div>}
        </>
    }

    return (<>

        {deleteModalOpen &&
            <DeleteConfirmation message={`Are you sure you want to remove ${candidateName} from pipeline ?`}
                                onConfirm={() => saveToPipeline('removeFromPipeline')}
                                setDetails={setDeleteModalOpen}
                                detailsInitialState={false}
                                isLoading={removeCandidateAPI.isLoading}/>}
        <div
            className={props.fullPage ? '' : (props.candidate?.showModal ? "sideBar_profile active" : "sideBar_profile")}>

            {!props.fullPage && <div className={candidateDataAPI.isSuccess && "pro_title_area side_panel_title"}>
                {candidateDataAPI.isSuccess && <h2>From Search Result</h2>}
                <Paginate
                    totalRecords={total}
                    type="footer-div"
                    nextPageNum={state.page}
                    getNextPage={getNextPage}
                    recordPerPage={1}
                    isLoading={candidateDataAPI.isLoading}
                    extra={<div className="close">
                        <img src={closeBtn} onClick={(e) => {
                            e.preventDefault();
                            props.hideDetailModal();
                            document.body.classList.remove('modal-open');
                        }} alt=""/>
                    </div>}
                />
            </div>}
            {candidateDataAPI.isSuccess &&
                <>
                    <div className="backbtn_title back_button"><a onClick={() => {
                        props.hideDetailModal();
                    }}>
                        {!props.fullPage && <img src={dataCircle} alt=""/>}
                        <span>From Search Result</span></a>
                    </div>
                </>
            }
            <div className={props.fullPage ? 'candidate_full_page' : "sidebar_section"}
                 style={props.fullPage ? {} : {}}>
                {props.fullPage && <div className={isCoffeemugMember ? "candidate_lc" : ''}>
                    <div className={isCoffeemugMember ? "left_sidebar" : ''}>
                        {isCoffeemugMember && <>
                            {/*<div className="widget_1 mb_64">
                                    <div className="meeting_row">
                                        <div className="metting_user_profile">
                                            <div>
                                                <img src={`${process.env.PUBLIC_URL}/assets/img/esha-garodia.png`}
                                                     alt=""/>
                                            </div>
                                            <div>
                                                <h4>Esha Garodia</h4>
                                                <h6>Relationship Manager</h6>
                                            </div>
                                        </div>
                                        <div className="metting_description">
                                            <p>Hi {user.name}, do you need customized end to end service in your talent
                                                search?</p>
                                            <a href="https://coffeemug.ai/reminder/" target="_blank" rel="noreferrer"
                                               className="btn btn_fill">Yes, connect with me</a>
                                            <a href="https://coffeemug.ai/reminder/" target="_blank" rel="noreferrer"
                                               className="btn btn_outline">Skip this week</a>
                                        </div>
                                    </div>
                                </div>*/}
                            <div className="widget_2 mb_64">
                                <div className="testimonials">
                                    <div className="testi_title">
                                        <h4>Leaders recommend CoffeeMug</h4>
                                        <h6>Here’s what they have to say</h6>
                                    </div>
                                    <div className="testi_content">
                                        <div className="testi_item_column">
                                            <div className="testi_items">
                                                <div className="testi_user">
                                                    <div>
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/assets/img/ramneek-khurana.png`}
                                                            alt=""/>
                                                    </div>
                                                    <div>
                                                        <h4>Ramneek Khurana</h4>
                                                        <h6>Co-Founder, Lenskart</h6>
                                                    </div>
                                                </div>
                                                <div className="testi_description">
                                                    <svg width="36" height="28" viewBox="0 0 36 28" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M3.166 25.642C1.106 23.454 0 21 0 17.022C0 10.022 4.914 3.748 12.06 0.645996L13.846 3.402C7.176 7.01 5.872 11.692 5.352 14.644C6.426 14.088 7.832 13.894 9.21 14.022C12.818 14.356 15.662 17.318 15.662 21C15.662 22.8565 14.9245 24.637 13.6117 25.9497C12.299 27.2625 10.5185 28 8.662 28C7.63532 27.991 6.62067 27.7779 5.67712 27.3731C4.73358 26.9683 3.87997 26.3798 3.166 25.642ZM23.166 25.642C21.106 23.454 20 21 20 17.022C20 10.022 24.914 3.748 32.06 0.645996L33.846 3.402C27.176 7.01 25.872 11.692 25.352 14.644C26.426 14.088 27.832 13.894 29.21 14.022C32.818 14.356 35.662 17.318 35.662 21C35.662 22.8565 34.9245 24.637 33.6117 25.9497C32.299 27.2625 30.5185 28 28.662 28C27.6353 27.991 26.6207 27.7779 25.6771 27.3731C24.7336 26.9683 23.88 26.3798 23.166 25.642Z"
                                                            fill="black" fillOpacity="0.3"/>
                                                    </svg>
                                                    <p>Lenskart has been working closely with the CoffeeMug platform
                                                        for
                                                        our senior-level hiring needs as a partner and our first
                                                        port of
                                                        call, especially in the engineering and product domain. We
                                                        have
                                                        firsthand experienced the team's capability to move fast
                                                        with
                                                        our ever-evolving hiring needs powered by their backend
                                                        hiring
                                                        engine, and it has delivered phenomenal results for us.</p>
                                                </div>
                                            </div>
                                            <div className="testi_items">
                                                <div className="testi_user">
                                                    <div>
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/assets/img/himanshu-verma.png`}
                                                            alt=""/>
                                                    </div>
                                                    <div>
                                                        <h4>Himanshu Verma</h4>
                                                        <h6>CPTO, Licious</h6>
                                                    </div>
                                                </div>
                                                <div className="testi_description">
                                                    <p>We have been working closely with the CoffeeMug team to
                                                        address
                                                        our mid to senior level tech & product hiring needs at
                                                        Licious,
                                                        and it stands head and shoulder above traditional players in
                                                        the
                                                        recruitment space. With CoffeeMug talent Solution, I am glad
                                                        to
                                                        see it taking shape as a productized offering in the
                                                        market.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="show_more">
                                            <a href="https://coffeemug.ai/talent-solutions/#ramneek" target="_blank"
                                               rel="noreferrer">
                                                See all Testimonials
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M5.6244 11.6245C5.48315 11.4832 5.40918 11.3035 5.4025 11.0852C5.39634 10.8669 5.46388 10.6871 5.60514 10.5458L9.38042 6.77056H0.770465C0.552167 6.77056 0.369053 6.69659 0.221124 6.54867C0.073708 6.40125 0 6.21839 0 6.00009C0 5.7818 0.073708 5.59868 0.221124 5.45075C0.369053 5.30334 0.552167 5.22963 0.770465 5.22963H9.38042L5.60514 1.45435C5.46388 1.3131 5.39634 1.13332 5.4025 0.915022C5.40918 0.696724 5.48315 0.516948 5.6244 0.375696C5.76565 0.234444 5.94543 0.163818 6.16372 0.163818C6.38202 0.163818 6.5618 0.234444 6.70305 0.375696L11.7881 5.46077C11.8652 5.52497 11.9199 5.6051 11.9522 5.70115C11.9841 5.79772 12 5.89737 12 6.00009C12 6.10282 11.9841 6.19913 11.9522 6.28902C11.9199 6.37891 11.8652 6.46237 11.7881 6.53942L6.70305 11.6245C6.5618 11.7657 6.38202 11.8364 6.16372 11.8364C5.94543 11.8364 5.76565 11.7657 5.6244 11.6245Z"
                                                        fill="#D8232A"></path>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="widget_3">
                                <div className="our_clients">
                                    <div className="our_clients_title">
                                        <h4>Our Clients</h4>
                                        <h6>We work with 60 plus clients</h6>
                                    </div>
                                    <div className="our_clients_images">
                                        <ul>
                                            <li><img src={`${process.env.PUBLIC_URL}/assets/img/logo_1.png`}
                                                     alt=""/></li>
                                            <li><img src={`${process.env.PUBLIC_URL}/assets/img/logo_2.png`}
                                                     alt=""/></li>
                                            <li><img src={`${process.env.PUBLIC_URL}/assets/img/logo_3.png`}
                                                     alt=""/></li>
                                            <li><img src={`${process.env.PUBLIC_URL}/assets/img/logo_4.png`}
                                                     alt=""/></li>
                                            <li><img src={`${process.env.PUBLIC_URL}/assets/img/logo_5.png`}
                                                     alt=""/></li>
                                            <li><img src={`${process.env.PUBLIC_URL}/assets/img/logo_6.png`}
                                                     alt=""/></li>
                                            <li><img src={`${process.env.PUBLIC_URL}/assets/img/logo_7.png`}
                                                     alt=""/></li>
                                            <li><img src={`${process.env.PUBLIC_URL}/assets/img/logo_8.png`}
                                                     alt=""/></li>
                                            <li><img src={`${process.env.PUBLIC_URL}/assets/img/logo_9.png`}
                                                     alt=""/></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </>}
                    </div>
                </div>}
                <div className={props.fullPage ? "author_des candidate_ce" : "author_des"}>
                    {detailsDiv}
                </div>

                <div
                    className={props.fullPage && isCoffeemugMember ? "autho_info_desk candidate_rc" : "autho_info_desk"}
                    style={props.fullPage ? {paddingLeft: ""} : {}}>
                    {githubAndSimilar}
                </div>
            </div>
        </div>
        <div
            className={props.candidate?.showModal ? "overley_sidebar sideBar_active active" : "overley_sidebar sideBar_active"}
            onClick={props.candidate?.showModal ? props.hideDetailModal : undefined}></div>
    </>)
}

CandidateDetails.propTypes = {
    hideDetailModal: PropTypes.func, forGithub: PropTypes.bool, filters: PropTypes.object,

    candidate: PropTypes.exact({
        showModal: PropTypes.bool, candidateId: PropTypes.string, position: PropTypes.number,
    })
}

export default CandidateDetails